import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';

import PageHeaderTitle from '../Common/Profile/PageHeaderTitle';
import MobileFooter from '../Common/Profile/MobileFooter';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { ListItemIcon } from '@material-ui/core';

import { withTranslation, Trans } from 'react-i18next';
import { hot } from 'react-hot-loader';

const GUARANTOR_STATE = window.AppConfig.GUARANTOR_STATE;

class DownloadDocuments extends Component {
	render() {
		const { t } = this.props;
		const docList = [
			{
				document: t('buttons.generate_loan_documentation'),
				action: this.props.openLoanAgreement
			}
		];

		if (this.props.loanObject.guarantor_action === GUARANTOR_STATE.ACCEPT) {
			docList.push({
				document: t('buttons.generate_loan_documentation_guarantor_lender'),
				action: this.props.openLoanAgreementLenderGuarantor
			});
			docList.push({
				document: t('buttons.generate_loan_documentation_guarantor_borrower'),
				action: this.props.openLoanAgreementBorrowerGuarantor
			});
		}

		return (
			<section className="download_document">
				<PageHeaderTitle title="Loan Details" onClick={this.props.closeDownloadDocuments} className="p-x-16" />
				<Grid
					container
					id="reduce-width"
					justify="center"
					style={{
						backgroundColor: '#FFFFFF',
						padding: '2rem',
						marginTop: '2rem'
					}}>
					<Grid id="shadow-round" item sm={8} xs={12} justify="center">
						<h3 variant="h3" className="download-documents-title">
							Download Printable Document as PDF Files
						</h3>
						<div>
							<List>
								{docList.map(d => {
									return (
										<ListItem onClick={d.action} className="dl-documents-list">
											<ListItemIcon>
												<img
													src="/images/download-pdf.png"
													alt="download-pdf"
													style={{ width: '5rem', height: '5rem' }}
												/>
											</ListItemIcon>
											<ListItemText primary={d.document} />
										</ListItem>
									);
								})}
							</List>
						</div>
					</Grid>
				</Grid>
				<MobileFooter onClick={this.props.closeDownloadDocuments} />
			</section>
		);
	}
}

export default hot(module)(withTranslation()(DownloadDocuments));
